import { render, staticRenderFns } from "./UpdateFieldModal.vue?vue&type=template&id=3d2dc753&scoped=true"
import script from "./UpdateFieldModal.vue?vue&type=script&lang=js"
export * from "./UpdateFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2dc753",
  null
  
)

export default component.exports